// extracted by mini-css-extract-plugin
module.exports = {"leftside":"ParentProductCard_leftside__nSb2e"};